<template>
  <section class="">
    <!-- 头部 -->
    <hd-header></hd-header>
    <section class="hd-web-content">
      <!-- banner-->
      <section class="banner">
        <div class="wrap" style="position: relative;height: 100%;">
          <h1 class="title">我要讲课</h1>
          <div class="line"></div>
          <div class="en">THE THREE MAJOR ADVANTAGES</div>
          <div class="tip">入驻海渡职校坐享三大优势</div>
          <div class="fenlei clear">
            <div class="item">
              <img src="~assets/images/icon_yingxiao.png" alt="">
              <h3>精准营销</h3>
              <p>
                <span>全网独家专注工业机器人</span>
                <br>
                <span>教育细分领域</span>
              </p>
            </div>
            <div class="item">
              <img src="~assets/images/icon_shenyuan.png" alt="">
              <h3>海量生源</h3>
              <p>
                <span>海渡职校全国分院地面教学</span>
                <br>
                <span>保障线上生源</span>
              </p>
            </div>
            <div class="item">
              <img src="~assets/images/icon_shouyi.png" alt="">
              <h3>多重收益</h3>
              <p>
                <span>点播与直播课程对应收益</span>
                <br>
                <span>高额回馈与奖励</span>
              </p>
            </div>
          </div>
        </div>
      </section>
      <!-- 入驻资格-->
      <section class="block zg">
        <div class="wrap">
          <h1 class="title">入驻资格</h1>
          <div class="line"></div>
          <div class="tip">什么资格可以成功开课</div>
          <div class="list clear">
            <div class="item">
              <img src="~assets/images/icon_geren.png" alt="">
              <h3>个人</h3>
              <p>工业机器人相关课程的院校老师</p>
              <p>制造业、自动化行业资深工程师</p>
            </div>
            <div class="item">
              <img src="~assets/images/icon_jigou.png" alt="">
              <h3>机构</h3>
              <p>营业执照标有教育、培训、咨询类机构用户</p>
              <p>开设课程属于工业机器人教育或相关衍生领域</p>
            </div>
          </div>
        </div>
      </section>
      <!-- 入驻和上课流程 -->
      <section class="block lc">
        <div class="wrap">
          <h1 class="title">入驻和上课流程</h1>
          <div class="line"></div>
          <div class="tip">入驻和开课都需要哪些流程?</div>
          <div class="list clear">
            <div class="item">
              <div class="step">1</div>
              <h3>信息提交</h3>
              <p>填写海渡职校入驻申请信息</p>
            </div>
            <div class="item">
              <div class="step">2</div>
              <h3>资格认可</h3>
              <p>3个工作日内进行认证</p>
            </div>
            <div class="item">
              <div class="step">3</div>
              <h3>合同签订</h3>
              <p>海渡工作人员和您签订合约</p>
            </div>
            <div class="item">
              <div class="step">4</div>
              <h3>课程上线</h3>
              <p>课程上线培训指导</p>
            </div>
          </div>
          <div class="info">
            <h2 class="title">入驻信息提交</h2>
            <div class="line-title">1.&nbsp;邮件标题：</div>
            <div class="line-content">
              机构/个人名称-入驻申请资料
            </div>
            <div class="line-title">2.&nbsp;邮件内容：</div>
            <div class="line-content">
              <p>(1)基本信息(申请入驻的课程介绍、课程目录、上线后的更新规划、以往开课经验等)；</p>
              <p>(2)资质信息(机构类提供最新营业执照扫描件、个人类提供教师资格证书/专业资格证书/高等学历扫描件)。</p>
            </div>
            <div class="line-title">3.&nbsp;接收邮箱：</div>
            <div class="line-content">
              <a href="mailto:edubot@hitrobotgroup.com" style="color: #0a9aeb;">edubot@hitrobotgroup.com</a>
            </div>
            <div class="corner"></div>
          </div>
        </div>
      </section>
      <!--底部 -->
      <hd-footer></hd-footer>
    </section>
  </section>
</template>
<script>
import hdHeader from '@/components/layout/hd-header'
import hdFooter from '@/components/layout/hd-footer'
export default {
  name: '',
  data() {
    return {

    }
  },
  created() {

  },
  components: {
    hdHeader,
    hdFooter
  },
  methods: {

  }
}

</script>
<style lang="scss" scoped>
.hd-web-content {
  position: relative;
  top: 72px;
}

.banner {
  background: url(~assets/images/img2.png) center no-repeat;
  background-size: cover;
  background-color: #2ebafe;
  width: 100%;
  height: 490px;
  text-align: center;
  padding-top: 84px;
  box-sizing: border-box;
  .title {
    font-size: 40px;
    color: #fff;
  }
  .line {
    width: 150px;
    height: 3px;
    background: #fff;
    margin: 20px auto;
  }
  .en {
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    position: relative;
    &:before {
      content: '';
      position: absolute;
      width: 220px;
      height: 1px;
      background: #fff;
      top: 50%;
      left: 80px;
    }
    &:after {
      content: '';
      position: absolute;
      width: 220px;
      height: 1px;
      background: #fff;
      top: 50%;
      right: 80px;
    }
  }
  .tip {
    font-size: 24px;
    color: #fff;
    margin-top: 20px;
  }
  .fenlei {
    display: flex;
    position: absolute;
    bottom: -95px;
    .item {
      width: 250px;
      height: 255px;
      background: #fff;
      margin-right: 108px;
      text-align: center;
      padding: 35px 28px;
      box-sizing: border-box;
      box-shadow: 0 0 5px #aaa;
      float: left;
      &:last-child {
        margin-right: 0;
      }
      &>p {
        line-height: 24px;
        font-size: 16px;
        color: #666666;
      }
      img {
        width: 82px;
        margin-bottom: 25px;
      }
      h3 {
        margin-bottom: 18px;
        font-size: 20px;
        color: #333333;
      }
    }
  }
}

.zg {
  padding-top: 170px;
  padding-bottom: 115px;
  border-bottom: 1px solid #ecedef;
  .list {
    display: flex;
    margin-top: 30px;
    .item {
      width: 436px;
      height: 348px;
      border: 1px solid #ecedef;
      margin-right: 78px;
      padding: 66px 0 40px 0;
      box-sizing: border-box;
      float: left;
      &:last-child {
        margin-right: 0;
      }
      h3 {
        font-size: 24px;
        color: #333333;
        margin: 20px 0;
      }
      p {
        color: #666666;
        font-size: 16px;
        margin-bottom: 12px;
      }
      img {
        width: 228px;
      }
    }
  }
}

.lc {
  padding-top: 65px;
  .list {
    display: flex;
    align-items: center;
    margin-top: 65px;
    .item {
      margin-right: 110px;
      float: left;
      &:last-child {
        margin-right: 0;
        .step:after {
          border-top: none;
        }
      }
      .step {
        width: 108px;
        height: 108px;
        border-radius: 50%;
        text-align: center;
        line-height: 108px;
        border: 1px solid #0a9aeb;
        color: #0a9aeb;
        font-size: 24px;
        margin: 0 auto 20px;
        position: relative;
        &:after {
          content: '';
          width: 100px;
          border-top: 1px dashed #dcdcdc;
          position: absolute;
          top: 54px;
          right: -120px;
        }
      }
      h3 {
        font-size: 20px;
        color: #333333;
        margin-bottom: 25px;
      }
      p {
        font-size: 16px;
        color: #666666;
      }
    }
  }
  .info {
    margin-top: 40px;
    margin-bottom: 50px;
    border: 1px solid #ecedef;
    text-align: left;
    padding: 25px 150px 40px 32px;
    position: relative;
    z-index: 10;
    .corner {
      width: 50px;
      height: 50px;
      background: linear-gradient(45deg, #fff 24%, #fff 40%, #fff 43%, #fff 46%, #ecedef 50%, #fff 50%, #fff);
      transform: rotate(-90deg);
      position: absolute;
      bottom: -1px;
      right: -1px;
      z-index: 22;
      overflow: hidden;
      transition: all 0.3s linear 0s;
      border-top: 1px solid #ecedef;
      border-right: 1px solid #ecedef;
    }
    .title {
      font-size: 24px;
    }
    .line-title {
      margin-top: 30px;
      font-size: 18px;
      color: #414141;
    }
    .line-content {
      padding-left: 14px;
      margin-top: 12px;
      font-size: 18px;
      color: #666666;
      &>p {
        margin-top: 12px;
        line-height: 1.5;
      }
    }
  }
}

.block {
  width: 100%;
  text-align: center;
  .title {
    font-size: 36px;
    color: #333333;
  }
  .line {
    width: 118px;
    height: 2px;
    background: #000;
    margin: 20px auto;
  }
  .tip {
    color: #666666;
    font-size: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// Settle.vue?116da6ba